import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import axios from 'axios';
import {API_URL} from '../../../constants';
import { toast } from 'react-toastify';
import cookie from 'react-cookies';
import {showModalPageClass, showLoader, hideLoader, setTestData, setDataForm, setTextInputLongitud, cleanDataForm} from '../../../functions';
import $ from 'jquery';

export default class Consejeros extends Component {

    constructor(props)
	{
        super(props);
    }

    state = {
        consejeros : [],
        actionForm: "",
        guardando: false
    }

    render() {
        return (
            <div>
                 <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                        <a href="/">
                            / Panel de configuración general
                        </a>
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Ficha País</span>
                        <span> / Consejeros</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Consejeros Comerciales
                </div>
                <div className="divSector_Panel">
                    <div className="divTablaPage_Panel">
                        <table border={1} cellSpacing={0}>
                            <tbody>
                                <tr>
                                    <th>N°</th>
                                    <th>Sede</th>
                                    <th>Nombre</th>
                                    <th>Cargo</th>
                                    <th>Email</th>
                                    <th width={"100"}>Acciones</th>
                                </tr>
                                {
                                    this.state.consejeros.length > 0 ? 
                                    
                                    this.state.consejeros.map((item, index) => (
                                        <tr key={`consejeros-${item.id}`}>
                                            <td>{index + 1}</td>
                                            <td>{item.sede}</td>
                                            <td>{item.nombre}</td>
                                            <td>{item.cargo}</td>
                                            <td>{item.email}</td>
                                            <td>
                                                <div className="divBtnAcciones">
                                                    <a href="#" className="btnPageModuloEditar" onClick={(event) => this.editarConsejero(event, item)}/>
                                                    <a href="#" className="btnPageModuloEliminar aEliminarMenu2"/>
                                                    <div className="c_divAlertaCapa">
                                                        <div className="divAlertaCapa">
                                                            <div className="divAlerta">
                                                                <h2>&iquest;Seguro de eliminar?</h2>
                                                                <div className="divAlertaBtn">
                                                                    <a href="#" className="btnAlertaAceptar" onClick={(event) => this.eliminarRegistro(event, item)}>ACEPTAR</a>
                                                                    <a href="#" className="btnAlertaCancelar">CANCELAR</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </td>
                                        </tr>
                                    ))

                                    :

                                    (
                                        <tr>
                                            <td colSpan="6" className="tdSinResultados">
                                                No se encontró resultados.
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        <div className="divContenedorBtn_Glosario">
                            <a href="" className="btnAddPalabraGlosario btnActivo" id="btnCreateGlosario" onClick={(e) => this.showCrearConsejero(e)}>AGREGAR </a>
                            <a href="" className="btnPrevAddPalabraGlosario" onClick={(event) => this.regresarFichaPais(event)}>VOLVER</a>
                        </div>
                        <div id="containerForm" style={{display:"none"}}>
                            <div className="divGlosario">
                                <h2>Formulario Consejero</h2>
                                <div className="containerFormCreate">
                                    <div className="divWrapperGlosario2">
                                        <div className="divAddPalabraGlosario">
                                            <div className="txtFile x-1">
                                                <input type="text" placeholder="Sede" id='Sede' maxLength={255} className="data-test data-form"/>
                                                <span id="longitudSede"></span>
                                            </div>
                                            <div className="txtFile x-1">
                                                <input type="text" placeholder="Nombre" id='Nombre' maxLength={255} className="data-test data-form"/>
                                                <span id="longitudNombre"></span>
                                            </div>
                                            <div className="txtFile x-1">
                                                <input type="text" placeholder="Cargo" id='Cargo' maxLength={255} className="data-test data-form"/>
                                                <span id="longitudCargo"></span>
                                            </div>
                                            <div className="txtFile x-1">
                                                <input type="text" placeholder="Email" id='Email' maxLength={255} className="data-test data-form"/>
                                                <span id="longitudEmail"></span>
                                            </div>
                                        </div>
                                        <div className="divContenedorBtn_Glosario">
                                            <input type="hidden" id="Id" className="data-form"/>
                                            <a href="" className="btnAddPalabraGlosario btnActivo" onClick={(event) => this.guardarForm(event)}>{this.state.actionForm == "G" ? "GUARDAR" :  "ACTUALIZAR"}</a>
                                            <a href="#" className="btnPrevAddPalabraGlosario" onClick={(event) => this.cancelarForm(event)}>CANCELAR</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    getConsejeros(){
        showLoader();

        const url = `${API_URL}FichaPaisConsejeroUX/ObtenerPorPaisCodigo?paisCodigo=${this.props.match.params.id}`;
        axios.get(url)
            .then(response => response.data)
            .then((data) => {
                hideLoader();
                
                this.setState({ 
                    consejeros: data.result.data
                });
            })
            .catch(error => {
                hideLoader();
                toast.error('Error al listar');
            });
    }

    regresarFichaPais(e) {
        e.preventDefault();

        const {history: {push}} = this.props;
        push('/ficha-pais');
    }  

    eliminarRegistro = (event, entity) => {
        event.preventDefault();

        const url = `${API_URL}FichaPaisConsejeroUX/Eliminar?id=` + entity.id ;
        const me = this;

        axios.post(url, {}, { 
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }).then((data)=> {
            
            me.setState({ guardando:false });
            
            if(data.data.result.status){
                toast.success('Consejero Eliminado.');
                this.getConsejeros();
                $("#containerForm").fadeOut();
            }
        }).catch((error)=> {
            toast.error('Error no controlado.');
            me.setState({ guardando:false });
        });
    }

    editarConsejero = (event, item) => {
        event.preventDefault();

        document.getElementById('Id').value = item.id;
        document.getElementById('Sede').value = item.sede;
        document.getElementById('Nombre').value = item.nombre;
        document.getElementById('Cargo').value = item.cargo;
        document.getElementById('Email').value = item.email;
        
        this.setState({
            actionForm: "U"
        });

        $("#containerForm").fadeIn();
    }

    showCrearConsejero = (event) => {
        event.preventDefault();

        cleanDataForm();

        this.setState({
            actionForm: "G"
        });

        document.getElementById('Id').value = "0";

        $("#containerForm").fadeIn();
    }

    guardarForm = (e) => {
        e.preventDefault();

        if(this.state.guardando == false){
            this.setState({ guardando: true });
            const me = this;
    
            const url = this.state.actionForm == "G" ? `${API_URL}FichaPaisConsejeroUX/Insertar` : `${API_URL}FichaPaisConsejeroUX/Actualizar`;
            
            let consejero = {
                "PaisCodigo": this.props.match.params.id
            };
            
            setDataForm(consejero);
    
            axios.post(url, JSON.stringify(JSON.stringify(consejero)),
            { 
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
                }
            }).then((data)=> {
                
                me.setState({ guardando:false });
                
                if(data.data.result.status){
                    toast.success(this.state.actionForm == "G" ? 'Consejero Agregado.' : 'Consejero Actualizado.');
                    this.getConsejeros();
                    $("#containerForm").fadeOut();
                }
            }).catch((error)=> {
                toast.error('Error no controlado.');
                me.setState({ guardando:false });
            });
        }
    }

    cancelarForm = (e) => {
        e.preventDefault();

        $("#containerForm").fadeOut();
    }
	
    componentDidMount()
	{
        this.getConsejeros();

        setTextInputLongitud(['Sede','Nombre','Cargo', 'Email']);
        //setTestData();
    }
}
